"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("react"),u=e=>{const r=t.useRef();return t.useEffect(()=>{e!==r.current&&(r.current=e)},[e]),r.current};exports.usePrevious=u;
